export var insuranceTypeDataForm = {
    Name: "",
    Img: "",
    id: "",
    clientId: "",
};
